module.exports = __webpack_public_path__ + "img/PM_10.8cce40a6.svg";